export default __webpack_public_path__ + "static/media/uniforme-policia-mujer.900ddf04.png";